// extracted by mini-css-extract-plugin
export default {"container":"Qo-z","brandName":"Ro-z","productName":"So-z","productNamePdpEnhancements":"To-z","breakLongProductName":"Uo-z"};